import { initTheme } from "./theme";
import { initNav } from "./nav";
import { initQuote } from "./quote";
import { initContact } from "./contact";
import "./styles.css";

initTheme();
initNav();
initQuote();
initContact();
